import { ScheduledTask, UnscheduledTask } from '../../services/schedule.types'
import { getDatasetColor } from '../../../gestionTache/utils/tacheUtilsTs'
import Badge from '@material-ui/core/Badge'
import React, { FC } from 'react'
import PeopleAltIcon from '@material-ui/icons/PeopleAlt'
import BuildIcon from '@material-ui/icons/Build'
import { getStyles } from 'isotope-client'
import { withStyles } from '@material-ui/core'
import Avatar from '@material-ui/core/Avatar'
import { colors } from '../../../../../utils/constants'
import NotificationImportantIcon from '@material-ui/icons/NotificationImportant'
import Chip from '@material-ui/core/Chip'
import LockIcon from '@material-ui/icons/Lock'

const styles = () => getStyles({
	delayed: {
		position: 'absolute' as 'absolute',
		top: 4,
		width: 16,
		height: 16,
		color: colors.error
	},
	badge: {
		minWidth: 10,
		height: 10,
		padding: 0,
		fontSize: 8,
		top: 3,
		right: 3
	},
	avatar: {
		height: 22,
		width: 22,
		fontSize: 8,
		border: '1px white solid',
		backgroundColor: 'transparent'
	},
	icon: {
		fontSize: '16px !important'
	},
	lockIcon: {
		position: 'absolute' as 'absolute',
		top: 4,
		height: 16,
		width: 16,
		color: 'inherit'
	}
})

type TaskCardProps = {
	id: string
	task: ScheduledTask | UnscheduledTask
	fromUnscheduled?: boolean
	highlighted?: boolean
	classes: ClassNameMap
}

// Style TaskCard pour tâche fraîchement déplanifiée
const HIGHLIGHT_BACKGROUND = 'lightgrey'
const HIGHLIGHT_FOREGROUND = '#333333'

const TaskCard: FC<TaskCardProps> = ({id, task, fromUnscheduled = false, highlighted = false, classes}) => {
	const classSuffix = fromUnscheduled ? '-unscheduled' : ''
	const cellColor = getDatasetColor(task.famille)
	const nbRessources = task.nbResourcesRequired
	const nbTools = Array.isArray(task.tools) ? task.tools.length : 1
	const hasRessourcesOrTools = nbRessources > 0 || nbTools > 0
	const titlePadding = 0 + (task.delayed ? 20 : 0) + (task.hasLock ? 20 : 0)

	const renderRessourcesOrTools = () => {
		if (hasRessourcesOrTools) {
			return <div className={`md-custom-event-icons${classSuffix}`}>
				{nbRessources > 0 && <Badge
					anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
					badgeContent={nbRessources}
					color="primary"
					classes={{ badge: classes.badge }}
				>
					<Avatar variant="circle" classes={{ root: classes.avatar }}>
						<PeopleAltIcon classes={{ root: classes.icon }} />
					</Avatar>
				</Badge>}
				{nbTools > 0 && <Badge
					anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
					badgeContent={nbTools}
					color="primary"
					classes={{ badge: classes.badge }}
				>
					<Avatar variant="circle" classes={{ root: classes.avatar }}>
						<BuildIcon classes={{ root: classes.icon }} />
					</Avatar>
				</Badge>}
			</div>
		}

		return <></>
	}

	return (
		<div className={`md-custom-event-cont${classSuffix}`} style={{ background: highlighted ? HIGHLIGHT_BACKGROUND : cellColor.background, color: highlighted ? HIGHLIGHT_FOREGROUND : cellColor.foreground }}>
			<div className={`md-custom-event-wrapper${classSuffix}`}>
				<div className={`md-custom-event-details${classSuffix}`}>
					<div className="md-custom-event-hidden">
						{id}
					</div>
					{task.delayed && <NotificationImportantIcon className={classes.delayed} />}
					{task.hasLock && <LockIcon className={classes.lockIcon} style={{ left: task.delayed ? 22 : 4 }} />}
					<div className="md-custom-event-title" style={{ paddingLeft: titlePadding }}>
						{`${task.title}${task.culture ? ` - ${task.culture}` : ''}`}
					</div>
					{(!task.planned || task.planche) && <div className="md-custom-event-subinfo">
						{task.planche &&
							<Chip
								label={task.planche}
								size="small"
								className="md-custom-event-chip"
							/>}
						{!task.planned &&
							<Chip
								label={`${Math.trunc(Number(task.duree))} min`}
								size="small"
								className="md-custom-event-chip"
							/>
						}
						{fromUnscheduled && renderRessourcesOrTools()}
					</div>}
					{!fromUnscheduled && renderRessourcesOrTools()}
				</div>
			</div>
		</div>
	)
}

export default withStyles(styles)(TaskCard)
